import { Alert, Box, Container, Divider, Fab, IconButton, Tooltip, Typography } from '@mui/material';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button } from '@mui/material';
import Grid from '@mui/material/Grid2';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { deleteMenuPhotoServiceAuth, deleteStorePhotoServiceAuth, fetchPhotosService, uploadMenuPhotoServiceAuth, uploadStorePhotoServiceAuth } from '../../services/appServices';
import { AppBarPadding, BottomPadding } from '../../utils/helperUtils';
import { theme } from '../../theme';
import LoadingComponent from '../components/LoadingComponent';
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import { useSnackbar } from '../../context/SnackbarContext';
import ConfirmDialogComponent from '../components/ConfirmDialogComponent';
import CloseIcon from "@mui/icons-material/Close";
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
function UpdatePhotoView() {
  const { slug } = useParams();
  const location = useLocation();
  const { login, logout } = useAuth();
  const navigate = useNavigate();
  const showSnackbar = useSnackbar();

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const [photos, setPhotos] = useState([]);

  const [selectedPhotoIndex, setSelectedPhotoIndex] = useState(-1);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [selectedPhoto, setSelectedPhoto] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);

  const [uploadDialogOpen, setUploadDialogOpen] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [alertOpen, setAlertOpen] = React.useState(true);

  // const handleDelete = (photo) => {
  //   console.log("Delete photo", photo);
  //   setPhotos((prev) => prev.filter(p => p.id !== photo.id));
  //   setConfirmDialogOpen(false);
  // };

  const isItemPhoto = location.pathname.includes('/update/photos/items');

  useEffect(() => {
    const getPhotos = async () => {
      setLoading(true);
      try {
        const endpoint = isItemPhoto
          ? `${slug}/menu_photos/`
          : `${slug}/storefront_photos/`;

        const response = await fetchPhotosService(endpoint);
        if (response.success) {
          setPhotos(response.data);
        } else {
          setPhotos([]);
          console.error("Failed to fetch photos:", response.error);
        }
      } catch (error) {
        console.error("Error fetching photos:", error);
        setError(error.message)
        setPhotos([]);
      } finally {
        setLoading(false);
      }
    };

    getPhotos();
  }, [slug, isItemPhoto, refreshKey]);

  const handleDelete = async () => {
    setLoading(true);
    try {

      const photo_id = selectedPhoto[`${isItemPhoto ? 'menu' : 'storefront'}_photo_id`]
      const response = isItemPhoto ? await deleteMenuPhotoServiceAuth(slug, photo_id, login, logout) :
        await deleteStorePhotoServiceAuth(slug, photo_id, login, logout);

      if (response.success) {
        showSnackbar("💣 Photo was deleted!", "success");
        setRefreshKey(prev => prev + 1);
        // Optionally trigger UI update
      } else {
        console.error("Failed to submit application:", response.error);
      }
    } catch (error) {
      setError(error.message)
      console.error("Error submitting application:", error);
    }
    finally {
      setDeleteDialogOpen(false)
      setConfirmDialogOpen(false)
      setTimeout(() => {
        setLoading(false);
      }, 3000);
    }
  }

  const handlePhotoUpload = async(files) => {
      try {
        setLoading(true);

        if(isItemPhoto) {
        await uploadMenuPhotoServiceAuth(files, slug, login, logout);
        }
        else {
          await uploadStorePhotoServiceAuth(files, slug, login, logout);
        }
      } catch (error) {
        console.error("Submittion error:", error);
        setError(`${error.message}` || "Something went wrong.");
      }
      finally {
        setTimeout(() => {
          setLoading(false);
        }, 3000);
      }
    showSnackbar(`${files.length} photo(s) uploaded successfully!`, "success");
    setRefreshKey(prev => prev + 1);
  };

  const FloatingActionButton = () => {
    return (
      <Tooltip title={"Add new Photos"} arrow>
        <Fab
          variant="extended"
          onClick={() => setUploadDialogOpen(true)}
          sx={{
            position: "fixed",
            bottom: 20,
            right: 20,
            backgroundColor: theme.colors.events.secondary,
            color: theme.colors.events.primaryDark,
            fontWeight: "bold",
            "&:hover": {
              backgroundColor: theme.colors.events.primary,
            },
          }}
        >
          <AddPhotoAlternateIcon sx={{ mr: 1 }} />
          Add New Photos

        </Fab>
      </Tooltip>
    );
  };

  return (
    <Box bgcolor={theme.colors.primary}>
      <Container maxWidth="xl" className="events-box-container">
        <AppBarPadding />
        <Grid container justifyContent={'center'}>
          <Grid size={{ md: 12, lg: 6 }} width={'100%'}>
            <Box display="flex" alignItems="center" mb={1}>
              <IconButton
                size="small"
                onClick={() => navigate(-1)}
                sx={{
                  color: theme.colors.events.secondary,
                  border: `1px solid ${theme.colors.events.secondary}`,
                  borderRadius: 3,
                  mr: 1
                }}
              >
                <ArrowBackIosNewIcon />
              </IconButton>
              <Typography fontSize={30} color={theme.colors.events.secondary} textAlign="left">
                <Box sx={{ fontWeight: 'bold' }}>
                  {isItemPhoto ? "Item/Menu Photos 📷" : "Storefront Photos 🖼️"}
                </Box>
              </Typography>
            </Box>
            <Divider sx={{ borderBottomWidth: 2, bgcolor: theme.colors.events.secondary }} />
            {
              error && (
                <Box textAlign="center" mt={4} className="box-container">
                  <Typography color="error" variant="h6">⚠️ {error || 'Something went wrong, please try again later'}</Typography>
                </Box>
              )
            }
            {loading ? (
              <Box mt={5}>
                <LoadingComponent fullScreen={false} />
              </Box>
            ) : (
              <>
                  <Box my={2}>
                   {alertOpen && <Alert severity="info" sx={{ borderRadius: 2 }} onClose={() => {setAlertOpen(false) }}>
                      Click on the photo for more options
                    </Alert>}
                  </Box>
                <Grid container spacing={2} mt={2}>
                  {photos.map((photo, index) => (
                    <Grid key={photo[`${isItemPhoto ? 'menu' : 'storefront'}_photo_id`]} size={{ xs: 4 }}>
                      <Box
                        sx={{
                          width: '100%',
                          paddingTop: '100%',
                          position: 'relative',
                          cursor: 'pointer',
                          borderRadius: 2,
                          overflow: 'hidden',
                          boxShadow: 1
                        }}
                        onClick={() => {
                          setSelectedPhoto(photo);
                          setSelectedPhotoIndex(index);
                          setConfirmDialogOpen(true);
                        }}
                      >
                        <img
                          src={photo[`${isItemPhoto ? 'menu' : 'storefront'}_photo`]}
                          alt={`photo-${index}`}
                          style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover'
                          }}
                        />
                      </Box>
                    </Grid>
                  ))}
                </Grid>
                <Dialog open={confirmDialogOpen} onClose={() => setConfirmDialogOpen(false)}>
                  <DialogTitle textAlign="center" sx={{ fontWeight: 'bold' }}>
                    What would you like to do?
                  </DialogTitle>
                  <DialogActions sx={{ justifyContent: 'center', pb: 3, gap: 3 }}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        setConfirmDialogOpen(false);
                        setLightboxOpen(true);
                      }}
                      sx={{ px: 3, py: 1.5, borderRadius: 5, textTransform: 'none' }}
                    >
                      👁️ View
                    </Button>
                    <Button
                      variant="outlined"
                      color="error"
                      onClick={() => setDeleteDialogOpen(true)}
                      sx={{ px: 3, py: 1.5, borderRadius: 5, textTransform: 'none' }}
                    >
                      🗑️ Delete
                    </Button>
                  </DialogActions>
                </Dialog>
                <Lightbox
                  open={lightboxOpen}
                  close={() => setLightboxOpen(false)}
                  slides={photos.map(p => ({ src: p[`${isItemPhoto ? 'menu' : 'storefront'}_photo`] }))}
                  index={selectedPhotoIndex}
                  render={{
                    buttonClose: () => (
                      <IconButton
                        onClick={() => setLightboxOpen(false)}
                        sx={{
                          top: 80,
                          right: 16,
                          zIndex: 9999,
                          backgroundColor: 'rgba(255,255,255,0.7)',
                          '&:hover': {
                            backgroundColor: 'rgba(255,255,255,0.9)',
                          }
                        }}
                      >
                        <CloseIcon sx={{ color: theme.colors.events.primaryDark }} />
                      </IconButton>
                    )
                  }}
                />
              </>
            )}
          </Grid>
        </Grid>
        <FloatingActionButton />
        {deleteDialogOpen && (
          <ConfirmDialogComponent
            dialogOpen={deleteDialogOpen}
            dialogTitle={`Are you sure you want to delete this photo?`}
            dialogContent="This action cannot be undone. The photo will be permanently deleted."
            primaryBtnText="Delete"
            secondaryBtnText="Cancel"
            primaryBtnBgColor={theme.colors.red}
            onSubmit={handleDelete}
            onClose={() => setDeleteDialogOpen(false)}
          />
        )}
        <Dialog
          open={uploadDialogOpen}
          onClose={() => {
            setUploadDialogOpen(false);
            setSelectedFiles([]);
          }}
          maxWidth="sm"
          fullWidth
          PaperProps={{
            sx: { borderRadius: 4, p: 2 }
          }}
        >
          <DialogTitle
            sx={{
              fontWeight: 'bold',
              textAlign: 'center',
              color: theme.colors.events.primaryDark,
            }}
          >
            📸 Upload New Photos
          </DialogTitle>
          <DialogContent dividers sx={{ pb: 1 }}>
            <Button
              variant="outlined"
              component="label"
              fullWidth
              sx={{ mb: 2, borderRadius: 2, borderStyle: 'dashed' }}
            >
              Click to Select Images
              <input
                type="file"
                hidden
                accept="image/*"
                multiple
                onChange={(e) =>
                  setSelectedFiles((prev) => [...prev, ...Array.from(e.target.files)])
                }
              />
            </Button>
            <Grid container spacing={2}>
              {selectedFiles.map((file, idx) => (
                <Grid size={{xs: 4}} key={idx}>
                  <Box
                    sx={{
                      position: "relative",
                      width: "100%",
                      paddingTop: "100%",
                      borderRadius: 2,
                      overflow: "hidden",
                      boxShadow: 1
                    }}
                  >
                    <img
                      src={URL.createObjectURL(file)}
                      alt={`preview-${idx}`}
                      style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        objectFit: "cover"
                      }}
                    />
                    <IconButton
                      size="small"
                      onClick={() =>
                        setSelectedFiles((prev) => prev.filter((_, i) => i !== idx))
                      }
                      sx={{
                        position: "absolute",
                        top: 4,
                        right: 4,
                        bgcolor: "rgba(255,255,255,0.8)",
                        '&:hover': { bgcolor: "rgba(255,255,255,1)" }
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </DialogContent>
          <DialogActions sx={{ justifyContent: "center", gap: 2, mt: 1 }}>
            <Button
              onClick={() => {
                setUploadDialogOpen(false);
                setSelectedFiles([]);
              }}
              variant="outlined"
              color="inherit"
              startIcon={<CloseIcon />}
              sx={{ borderRadius: 5, px: 3, py: 1.2, textTransform: "none" }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                handlePhotoUpload(selectedFiles);
                setUploadDialogOpen(false);
                setSelectedFiles([]);
              }}
              disabled={selectedFiles.length === 0}
              sx={{ borderRadius: 5, px: 3, py: 1.2, textTransform: "none" }}
            >
              📤 Upload
            </Button>
          </DialogActions>
        </Dialog>
        <BottomPadding />
      </Container>
    </Box>
  )
}

export default UpdatePhotoView